import React, { useContext, useReducer } from 'react';
import { getCoachesByClub, listCoachs } from '../graphql/queries';
import { API } from 'aws-amplify';
import { deleteCoach, updateCoach } from '../graphql/mutations';
import { AppContext } from './app';

const CoachContext = React.createContext();
const _coachState = {
    coaches : []
};

function coachReducer(state , {type , data}){
    switch (type) {
        case "SET_COACHES" : {
            return {
                ...state,
                coaches : data
            };
        }
        default:
            break;
    }
}

const CoachProvider = ({ children }) => {
    const [coachState, dispatch  ] = useReducer(coachReducer , _coachState);
    const { appState : {user : { sub } } , setUserProfile } = useContext(AppContext);
    async function getCoaches(){
        try {
            const r = await API.graphql({query : listCoachs});
            const {data  : { listCoachs : {items : coaches}}} = r;
            dispatch({type : "SET_COACHES" , data : coaches});
        } catch (err) {
            console.log(err);
        }
    }
    async function getCoachesForClub(clubID){
        try{
            const {data : {getCoachesByClub  : {items : coaches}}}  = await API.graphql({query : getCoachesByClub , variables : {clubID}});
            dispatch({type : "SET_COACHES" , data : coaches});
        }
        catch(err){
            console.log(err);
        }
    }
    async function UpdateCoach(details){
        return await API.graphql({query : updateCoach , variables : {input : details} });
    }
    async function removeCoach(details){
        return await API.graphql({query : deleteCoach , variables : {input : details} });
    }
    async function SetCoachProfile(){
        try{
            const {data  : { listCoachs : { items : profile}}}  =  await API.graphql({query : listCoachs , variables : {filter: { userId: { eq :  sub } } } });
            setUserProfile(profile[0]);
        }
        catch(err){
            console.log(err);
        }    
    }
    return (
        <CoachContext.Provider value={{ coachState , getCoaches , getCoachesForClub ,UpdateCoach , SetCoachProfile, removeCoach}}>
            {children}
        </CoachContext.Provider>
    );
};
export { CoachContext , CoachProvider};